/*
loading: false,
        responseBody: (action.type) ? action : action.payload.error,
        error: action.payload.message,
        errorObject:action.payload
        */
import DataModel from './dataModel';
import moment from 'moment';
 
        class SearchconsoleModel extends DataModel{
                    constructor(report){
                        super(report);
                        this.api = "Searchconsole";
                        
                         
                        for (var ks of Object.keys(report)){
                            if (this[ks.toLowerCase() + "Report"]){
                            
                                this[ks.toLowerCase() + "Report"](report[ks]);
                            }
                        }
                         
                         
                        
                }
        
                  
                    
                      
                    queriesReport(arr){
                        var resp = {current:{},categories:{query:{current:{},compare:{},keys:[]}}};
                        for (var i of arr) {
                        resp.keys = Object.keys(i.current[0]);
                        delete resp.keys["keys"];
                        i.current.map((c,k) => {
                            var idx = c.keys.pop();
                            resp.categories.query.keys[k] = idx;
                            
                            for (var ks of resp.keys){
                                var kidx = resp.keys.indexOf(ks);
                                if (ks != "keys"){
                                if (c[ks]){
                                    resp.categories.query.totals = resp.categories.query.totals ? resp.categories.query.totals : [];
                                    resp.categories.query.totals[kidx] = resp.categories.query.totals[kidx] ? resp.categories.query.totals[kidx] : 0
                                    resp.categories.query.totals[kidx] = resp.categories.query.totals[kidx]+parseInt(c[ks]);
                                    
                                    resp.categories.query.current[idx] = resp.categories.query.current[idx] ? resp.categories.query.current[idx] : [];
                                    resp.categories.query.current[idx][kidx] = parseInt(c[ks])
                                }
                            }
                            }
                        })
                    }
                        this.queries = this.setTotals(resp);
                    }

                    metricsReport(arr){
                        var resp = {current:{}};
                        for (var i of arr) {
                        resp.keys = Object.keys(i.current[0]).map((dk) => {return (dk != "keys") ? dk : null}).filter(a=>a);
                        i.current.map((c) => {
                            var idx = moment(c.keys.pop()).unix();
                            resp.current[idx] = (resp.current[idx]) ? resp.current[idx] : [];
                            var entry = {metrics:[],segments:{date:idx}};
                            for (var ks of resp.keys){
                                if (c[ks]){
                                    entry.metrics.push(c[ks]);
                                }
                            }
                            resp.current[idx].push(entry);

                        })
                    }
                        this.metrics = this.setTotals(resp);
                    }
                   
        
                
                }
        export default SearchconsoleModel;
                  
        
        